export default __webpack_public_path__ + "static/media/kenya-flag.825cc4a8.png";